export default function InnovationManifesto() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20atmospheric%20gradient%20with%20soft%20diffused%20light%20passing%20through%20frosted%20glass%20panels%2C%20cream%20and%20charcoal%20tones%2C%20ethereal%20ambient%20lighting%2C%20no%20people%2C%20no%20objects%2C%20pure%20abstract%20atmosphere%2C%20minimalist%20texture%2C%20cinematic%20mood%2C%20soft%20focus&width=1800&height=1000&seq=innovation-manifesto-technopankai&orientation=landscape"
          alt="Atmospheric abstract gradient with soft diffused lighting"
          title="Innovation manifesto background"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 tracking-wide leading-none mb-8">
          FUTURE-READY
        </h2>
        <p className="font-body text-lg md:text-xl text-background-200/90 max-w-[560px] mx-auto leading-relaxed font-light">
          We build systems designed not just for today's requirements, but for the challenges of tomorrow.
        </p>
      </div>
    </section>
  );
}